import React from "react";

interface ActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "primary" | "secondary" | "danger" | "success" | "outline";
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  className = "",
  icon,
  type = "button",
}) => {
  const baseClasses = `group font-bold rounded-xl shadow-large hover:shadow-xl 
    transition-all duration-300 transform hover:scale-[1.01] 
    disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none 
    flex items-center gap-3`;

  const variantClasses = {
    primary:
      "bg-gradient-to-r from-sky-600 to-sky-700 hover:from-sky-700 hover:to-sky-800 text-white",
    secondary:
      "bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white",
    danger:
      "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white",
    success:
      "bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white",
    outline:
      "bg-white dark:bg-slate-800 border-2 border-gray-300 dark:border-slate-600 hover:border-gray-400 dark:hover:border-slate-500 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-700",
  };

  const sizeClasses = {
    sm: "py-2 px-4 text-sm",
    md: "py-4 px-8",
    lg: "py-6 px-10 text-lg",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {icon && <span className="flex items-center [&>.MuiSvgIcon-root]:!text-xl">{icon}</span>}
      {loading ? "Carregando..." : children}
    </button>
  );
};
